import { render, staticRenderFns } from "./client-companies.vue?vue&type=template&id=2ac50d25"
import script from "./client-companies.vue?vue&type=script&lang=js"
export * from "./client-companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports